/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */

enum OS {
    WINDOWS = 'windows',
    LINUX = 'linux',
    MAC = 'mac',
}

/* Windows */
enum PACKAGE_IDS_WINDOWS {
    INSTALLER_CONTROL = 'installerControl',
    INSTALLER_CONTROL2015 = 'installerControl2015',
    INSTALLER_SERVICE = 'installerService',
    INSTALLER_SERVICE2015 = 'installerService2015',
    SUPER_HOST = 'superHost',
    INSPECTION_HOST = 'inspectionHost',
    MACHINECERT_SERVICE = 'machineCertService',
    INSPECTOR_SERVICE = 'inspectorService',
    PLUGIN_HOST = 'pluginHost',
}

interface IComponentPackageWin {
    id: string;
    version: string;
    url: string;
}

type IComponentPackagesWindows = Record<PACKAGE_IDS_WINDOWS, IComponentPackageWin>;

interface IClientConfigurationWindows {
    os: OS.WINDOWS;
    installerURL: string;
    scheme: string;
    packages: IComponentPackagesWindows;
    packageList: PACKAGE_IDS_WINDOWS[];
}

/* Mac */
enum PACKAGE_IDS_MAC {
    INSPECTION_HOST = 'inspectionHost',
}

interface IComponentPackageMac {
    id: string;
    version: string;
    mimeType: string;
    url: string;
    manualUrl: string;
}
type IComponentPackagesMac = Record<PACKAGE_IDS_MAC, IComponentPackageMac>;

interface IClientConfigurationMac {
    os: OS.MAC;
    installerURL: string;
    scheme: string;
    packages: IComponentPackagesMac;
}

/* Linux */
interface ILinuxInstallerUrl {
    id: string;
    url: string;
}

interface IClientConfigurationLinux {
    os: OS.LINUX;
    installerURLs: ILinuxInstallerUrl[];
    scheme: string;
}

/* Mass */
type IClientConfiguration = IClientConfigurationWindows | IClientConfigurationLinux | IClientConfigurationMac;

enum PROGRESS_STATUS {
    // 'getting_status' - fired when status is about to be checked;
    obtaining_status = 'obtaining_status',
    // 'awaiting_connection' - fired when APM is expecting client to connect to
    //     perform check;
    awaiting_connection = 'awaiting_connection',
    // 'token_value' - fired when client sent a token to the server
    token_value = 'token_value',
    // 'done' - comes when all check are done, onComplete is called
    //     onProgress is nod called;
    done = 'done',
    // 'expired' - fired when session check become expired;
    expired = 'expired',

    // 'check_client'
    check_client = 'check_client',
    // 'activex_required' - when activeX is required but can't be installed
    activex_required = 'activex_required',
    // 'restart_client_install' - client need to be restarted to install
    restart_client_install = 'restart_client_install',
    // 'installing_message' - when activex is being installed
    installing_message = 'installing_message',
}

enum scError {
    failedToSendRequest = 1110, // Failed to start XMLHttpRequest
    failedToParse = 1111, // JSON engine fails to parse data
    transferFailed = 1112, // XMLHttpRequest request is interrupted
    sessionExpired = 1113, // session is expired
}

export {
    IClientConfiguration,
    IComponentPackageWin as IComponentPackage,
    IComponentPackagesWindows,
    IComponentPackagesMac,
    IComponentPackageMac,
    PROGRESS_STATUS,
    scError,
    OS,
    PACKAGE_IDS_WINDOWS,
};
